<template>
  <b-tabs>
    <b-tab title="Requirements Sourced">
      <requirements :requirementArr="requirementOffers" />
    </b-tab>
  </b-tabs>
</template>

<script>
import Requirements from '@/shared/components/Requirements';
import { mapActions } from 'vuex';

export default {
  components: {
    Requirements
  },
  data: () => ({
    requirementOffers: [],
  }),
  props: {
    offerId: [Number, String]
  },
  methods: {
    ...mapActions('requirements', ['getByOfferId']) 
  },
  async mounted() { 
    if (this.offerId) {
      this.requirementOffers = await this.getByOfferId(this.offerId);
      console.log(this.requirementOffers, 'Requirement Offers')
    }
  }
};
</script>

<style lang="scss">
.offer--vendor-parts {
  margin-top: 20px;
}
</style>
